const renderIcon = (itemId) => {
  let icon = '';
  switch (itemId) {
    case 1:
      icon = 'panorama_fish_eye';
      break;
    case 2:
      icon = 'add';
      break;
    case 3:
      icon = 'clear';
      break;
    case 4:
      icon = 'remove';
      break;
    case 5:
      icon = 'remove';
      break;
    case 6:
      icon = 'crop_square';
      break;
    case 7:
      break;
    case 8:
      icon = 'crop_square';
      break;
    case 9:
      icon = 'star_border';
      break;
    case 10:
      icon = 'change_history';
      break;
  }

  return `<i class="material-icons nominal-point-shape nominal-point-shape-${itemId}">${icon}</i>`;
};

export default renderIcon;



// WEBPACK FOOTER //
// ./App/config/pointShapeIconRenderer.js